/**
 * @description Barra de navegação mobile para o modo interno
 * @module MainContent
 * @since Fevereiro 2024
 */

import { styled } from "@mui/material";

import { drawerWidth } from "../PrivateMainLayout";

const MainContent = styled("main", {
  // Evita que props internas virem atributos HTML no DOM.
  shouldForwardProp: (prop) =>
    prop !== "open" && prop !== "shouldShiftForDrawer",
})<{
  open?: boolean;
  isMediumScreen?: boolean;
  shouldShiftForDrawer?: boolean;
}>(({ theme, open, isMediumScreen, shouldShiftForDrawer }) => {
  return {
    flexGrow: 1,
    padding: theme.spacing(isMediumScreen ? 2 : 1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: shouldShiftForDrawer && !open ? `-${drawerWidth}px` : 0,
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    }),
    backgroundColor: "#F4F6F8",
    minHeight: `calc(100vh - ${isMediumScreen ? "64" : "112"}px)`,
    overflow: "auto",
    ...(!isMediumScreen && {
      marginBottom: "50px",
    })
  };
});
export { MainContent };
